import { Grid, Typography, Box } from '@mui/material';
import { LayoutChannelsWeb } from '../../../../layout/channels-web';
import { useLocation } from 'react-router-dom';

export const ChannelsWebThankYou = () => {
    const location = useLocation();
    const name = location.state?.name || '';
    return (
        <>
            <LayoutChannelsWeb />
            <Grid
                container
                sx={{
                    height: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f8f8f8',
                }}
            >
                <Box sx={{ maxWidth: '900px', padding: '24px' }}>
                    <Typography variant="h4" fontWeight="bold" gutterBottom>
                        Apreciado Cliente
                    </Typography>
                    <Typography variant="body1" fontWeight="bold" gutterBottom>
                        {name}
                    </Typography>
                    <Typography variant="body1" fontWeight="bold" gutterBottom>
                        <strong>DECLARACIÓN Y AUTORIZACIÓN:</strong> Al
                        diligenciar el formulario, ha declarado conocer y estar
                        informado de los canales de comunicación que pueden ser
                        utilizados por LA PREVISORA SEGUROS para realizar
                        gestiones comerciales y de cobranza.
                    </Typography>
                    <Typography variant="body1" fontWeight="bold" gutterBottom>
                        <strong>
                            Ha actualizado exitosamente sus preferencias de
                            contacto.
                        </strong>
                    </Typography>
                </Box>
            </Grid>
        </>
    );
};
